import { Action } from '@doveit/bricks';
import React from 'react';
import { Contact } from '../../../../providers/api/dtos';
import {
  DUPLICATE_CONTACT_MODAL_DESCRIPTION, DUPLICATE_CONTACT_MODAL_TITLE, OVERWRITE_IMPORTANT_DATA_MODAL_DESCRIPTION, OVERWRITE_IMPORTANT_DATA_MODAL_TITLE, POTENTIAL_DUPLICATE_CONTACTS_MODAL_DESCRIPTION, POTENTIAL_DUPLICATE_CONTACTS_MODAL_TITLE,
} from '../constants';
import { findDuplicateContact } from '../../../utils/findDuplicateContact';
import { ResolveConflictsModalData } from '../interfaces';
import { ContactStatus } from '../types';

export function computeResolveConflictsModalData(
  status: ContactStatus,
  overwriteContactValues: Partial<Contact> | undefined,
  potentialDuplicates: Contact[] | undefined,
  createNewContact: () => void,
  onContinueClick: () => void,
): ResolveConflictsModalData | undefined {
  switch (status) {
    case 'POTENTIAL_DUPLICATE':
      return {
        title: POTENTIAL_DUPLICATE_CONTACTS_MODAL_TITLE,
        description: POTENTIAL_DUPLICATE_CONTACTS_MODAL_DESCRIPTION,
        actions: [
          <Action
            key="continua"
            label="Continua"
            onClick={onContinueClick}
          />,
        ],
        canSubmit: true,
        duplicates: potentialDuplicates ?? [],
      };

    case 'DUPLICATE': {
      const duplicateContact = findDuplicateContact(overwriteContactValues, potentialDuplicates);
      return {
        title: DUPLICATE_CONTACT_MODAL_TITLE,
        description: DUPLICATE_CONTACT_MODAL_DESCRIPTION,
        actions: [],
        canSubmit: false,
        duplicates: duplicateContact ? [duplicateContact] : [],
      };
    }
    case 'OVERWRITE_IMPORTANT_DATA':
      return {
        title: OVERWRITE_IMPORTANT_DATA_MODAL_TITLE,
        description: OVERWRITE_IMPORTANT_DATA_MODAL_DESCRIPTION,
        actions: [
          <Action
            key="crea-nuovo-contatto"
            label="Crea nuovo contatto"
            onClick={createNewContact}
          />,
          <Action
            key="continua"
            label="Continua"
            onClick={onContinueClick}
          />,
        ],
        canSubmit: true,
        duplicates: [],
      };

    default:
      return undefined;
  }
}
